export function getMarginX(thumbSize: number): number {
  // Calculate the square diagonal
  // Divide it by two
  return Math.round((Math.sqrt(2) * thumbSize) / 2);
}

export function getMarginY(thumbSize: number, trackHeight: number): number {
  // Calculate the square diagonal
  // Divide it by two
  // Substrat half of the track height
  return Math.round(
    (Math.sqrt(2) * thumbSize) / 2 - Math.round(trackHeight / 2)
  );
}
